import { useEffect, useState, useContext } from "react";
import { NavLink } from "react-router-dom";
import { ConfigContext } from "../Context/ConfigContext";
import { useTranslation } from "react-i18next";
import "./login.css";
import { axiosPost } from "../Apis/axiosMethods";
import Config from "../appConfig";

const LoginPage = () => {

    const { setLoginStatus, setToken } = useContext(ConfigContext);
    const { t } = useTranslation();

    const [showPassword, setShowPassword] = useState(false);
    const [isDisable, setIsDisable] = useState(false);
    const [showDiscountComponents, setShowDiscountComponents] = useState(false);


    useEffect(() => {
        const loadDiscountComponents = () => {
            setShowDiscountComponents(true);
        };

        if ("requestIdleCallback" in window) {
            const idleId = window.requestIdleCallback(loadDiscountComponents, { timeout: 1000 });
            return () => window.cancelIdleCallback(idleId);
        }

        const timeoutId = setTimeout(loadDiscountComponents, 100);
        return () => clearTimeout(timeoutId);
    }, []);

    const [messages, setMessages] = useState({
        error_message_for_SignIn: '',
        success_message_for_SignIn: '',
        error_message_for_SignUp: '',
        success_message_for_SignUp: ''
    });

    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email_address: '',
        mobile_number: '',
        password: '',
        country_code: '',
        user_id: '',
        login_password: '',
        user_confirm_password: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            setIsDisable(true);

            const { user_id, login_password } = formData;
            const loginData = {
                login_id: user_id,
                login_password: login_password
            };

            const response = await axiosPost("/Users/Login", loginData);

            if (response?.data?.success) {

                const user = response?.data.data[0];

                localStorage.setItem("token", user.token);
                localStorage.setItem("business_ledger_id", user.business_ledger_id);
                localStorage.setItem("business_type", user.business_type);
                localStorage.setItem("business_user_id", user.business_user_id);
                localStorage.setItem("business_id", user.business_id);
                localStorage.setItem("business_delivery_days", response.business_delivery_days || "");
                localStorage.setItem("business_name", user.business_name);
                localStorage.setItem("email_address", user.business_email);
                localStorage.setItem("currency", user.currency);
                localStorage.setItem("min_purchase", user.min_purchase);

                localStorage.setItem("first_name", user.user_name);
                localStorage.setItem("mobile_number", user.business_contact_number);
                localStorage.setItem("purchaser", user.purchaser);

                localStorage.setItem("business_reward_point_x", user.business_reward_point_x);

                localStorage.setItem("AccountLocked", response?.data.lock ? "lock" : "unlock");

                setToken(user.token);

                setMessages({
                    ...messages,
                    success_message_for_SignIn: response.message || "Login Successfully",
                    error_message_for_SignIn: "",
                });

                setLoginStatus(true);

                setTimeout(() => {
                    window.location.href = "/";
                }, 1000);

            } else {

                setMessages({
                    ...messages,
                    error_message_for_SignIn: response.message || "Login Failed",
                    success_message_for_SignIn: "",
                });

            }

        } catch (error) {

            console.error("Error:", error);

            setMessages({
                ...messages,
                error_message_for_SignIn: "An error occurred while logging in.",
                success_message_for_SignIn: ''
            });

        } finally {
            setIsDisable(false);
        }
    };

    return (
        <div className="login-container-login">

            {showDiscountComponents && (
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="bg-video"
                >
                    {
                        Config.country === "uae" ?
                            <source
                                src="/assets/images/videos/login_page.mp4"
                                type="video/mp4"
                            />
                            : Config.country === "ksa" ?
                                <source
                                    src="/assets/images/videos/ksa_login_page.mp4"
                                    type="video/mp4"
                                />
                                : null
                    }
                </video>
            )}

            <div className="login-overlay">
                <div className="row">
                    <div className="col-md-12">
                        <div className="login-form-container mt-5">

                            <div className="login-header">
                                <h2>{t('login')}</h2>
                                <p>Welcome back! Please enter your details</p>
                            </div>

                            <form onSubmit={handleLogin} className="login-form">

                                <div className="form-group">
                                    <label htmlFor="login-email">
                                        Login ID
                                        <span className="required">*</span>
                                    </label>

                                    <input
                                        type="text"
                                        className="form-control"
                                        id="User_id"
                                        name="user_id"
                                        required
                                        value={formData.user_id}
                                        onChange={handleChange}
                                        placeholder="Enter login ID"
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="login-password">
                                        {t('password')}
                                        <span className="required">*</span>
                                    </label>

                                    <div className="password-input">
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            className="form-control"
                                            id="login_password"
                                            name="login_password"
                                            required
                                            value={formData.login_password}
                                            onChange={handleChange}
                                            autoComplete={false}
                                            placeholder="Enter you password"
                                        />

                                        <span
                                            className="password-toggle"
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            <i
                                                className={
                                                    showPassword
                                                        ? 'far fa-eye-slash'
                                                        : 'far fa-eye'
                                                }
                                            ></i>
                                        </span>
                                    </div>
                                </div>

                                <div className="form-options">

                                    <label className="checkbox-container">
                                        <input
                                            type="checkbox"
                                            id="lost-password"
                                        />
                                        <span className="checkmark"></span>
                                        {t('remember_me')}
                                    </label>

                                    <NavLink
                                        to="/Forget-Password"
                                        className="forgot-link"
                                    >
                                        Forget Password?
                                    </NavLink>

                                </div>

                                <button
                                    type="submit"
                                    className="login-button"
                                    disabled={isDisable}
                                >
                                    {isDisable ? "Logging ..." : "Login"}
                                </button>

                                <div className="m-4 text-center">
                                    <NavLink
                                        to="/Registration"
                                        className="forgot-link"
                                    >
                                        Registration
                                    </NavLink>
                                </div>

                                {messages.error_message_for_SignIn && (
                                    <div className="alert alert-danger">
                                        {messages.error_message_for_SignIn}
                                    </div>
                                )}

                                {messages.success_message_for_SignIn && (
                                    <div className="alert alert-success">
                                        {messages.success_message_for_SignIn}
                                    </div>
                                )}

                            </form>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default LoginPage;